export interface HomeLoadTiming {
    stage: string;
    outcome: 'complete' | 'error' | 'timeout' | 'cancelled';
    duration_ms: number;
    list_ms?: number;
    first_item_ms?: number;
    item_count: number;
    expected_count?: number;
    attempt: number;
}

const listeners = new Set<(timing: HomeLoadTiming) => void>();
export function subscribeHomeLoads(listener: (timing: HomeLoadTiming) => void) {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
}

/** One terminal record per attempt; no entity IDs, names, response bodies or exception text. */
export function startHomeLoad(stage: string, attempt: number) {
    const start = performance.now();
    let ended = false;
    const phases: { list_ms?: number; first_item_ms?: number } = {};
    const elapsed = () => Math.round(performance.now() - start);
    return {
        list: () => { phases.list_ms = elapsed(); },
        first: () => { if (phases.first_item_ms === undefined) phases.first_item_ms = elapsed(); },
        finish: (outcome: HomeLoadTiming['outcome'], item_count = 0, expected_count?: number) => {
            if (ended) return;
            ended = true;
            const timing = { stage, outcome, duration_ms: elapsed(), ...phases, item_count, expected_count, attempt };
            // Keep only the latest 100 records in the browser's standard Performance timeline.
            try {
                const entries = performance.getEntriesByName('wpa:home-load');
                if (entries.length >= 100) performance.clearMeasures('wpa:home-load');
                performance.measure('wpa:home-load', { start, end: performance.now(), detail: timing });
            } catch (_) { /* Older browsers may not support measure options. */ }
            listeners.forEach(listener => { try { listener(timing); } catch (_) { /* Never block loading on telemetry. */ } });
        },
    };
}
